import * as React from "react";
import { Wizard3ppPWAProps } from "./typings";
import { inject, observer } from "mobx-react";
import { Wizard3ppPWAView } from "./Wizard3ppPWAView";

@inject("wizardState")
@observer
export class Wizard3ppPWA extends React.Component<Wizard3ppPWAProps> {
  constructor(props: Wizard3ppPWAProps) {
    super(props);
    const { thirdPartyPackageWizardState } = this.props.wizardState;
    const { visibleLobSubtitle } = this.props.flexComponent.model;

    thirdPartyPackageWizardState.overrideConfig(() => {
      thirdPartyPackageWizardState.config.elementId = this.props.flexComponent.id;
      thirdPartyPackageWizardState.config.heading.fixedTitle = this.props.flexComponent.model.fixedLobTitle;
      thirdPartyPackageWizardState.config.lastSearch.useLastSearchForSingleLOB = this.props.flexComponent.model.useLastSearchForSingleLOB;
      thirdPartyPackageWizardState.config.heading.lobSubtitleBreakPoint = this.props.flexComponent.model.lobSubtitleBreakPoint;
      thirdPartyPackageWizardState.config.heading.hideLobTitle = this.props.flexComponent.model.hideLobTitle;
      thirdPartyPackageWizardState.config.heading.visibleLobSubtitle =
        visibleLobSubtitle ?? thirdPartyPackageWizardState.config.heading.visibleLobSubtitle;
    });

    thirdPartyPackageWizardState.updateStateFromCookie();
    thirdPartyPackageWizardState.updateDateFromConfig();
  }

  public render() {
    return <Wizard3ppPWAView {...this.props} />;
  }
}

export default Wizard3ppPWA;
